import { UserInfo } from '@/types/account';

import {
  RESET_ACCOUNT_INFO,
  SET_DISCOUNT_COPY,
  SHOW_FAVORITE_TIP,
  SYNC_ACCOUNT_INFO,
  SYNC_ADDRESS_BOOK,
  SYNC_COMMON_BAR_COPY,
  SYNC_FAVORITE_CLICK,
  SYNC_FAVORITE_IDS,
  SYNC_LOGIN_STATE,
  SYNC_PDP_SOLDOUT_TIP,
  SYNC_REWARDS_INFO,
  SYNC_USER_BOUGHT_DATA,
  SYNC_USER_PRE_ORDER_LOGIN
} from './actions';

export interface IExtraAccountAttrs {
  userPreOrderLogged: boolean;
  favoriteClicked: boolean;
  pdpSoldoutTip: boolean;
}

export const initState: UserInfo & IExtraAccountAttrs = {
  isLogin: false,
  favoriteIds: [],
  addresses: [],
  couponNumber: '',
  rewardsInfo: {},
  show_favorite_tip: false,
  favoriteIdsLoaded: false,
  userPreOrderLogged: true,
  commonBarCopy: null,
  favoriteClicked: false,
  userBoughtData: [],
  pdpSoldoutTip: true
};

export default function reducers(state: UserInfo = initState, action) {
  const { payload } = action;
  switch (action.type) {
    case SYNC_ACCOUNT_INFO:
      return {
        ...state,
        ...payload
      };
    case RESET_ACCOUNT_INFO:
      return {
        ...initState,
        isLogin: false
      };
    case SYNC_LOGIN_STATE:
      return {
        ...state,
        isLogin: payload
      };
    case SYNC_FAVORITE_IDS:
      return {
        ...state,
        favoriteIds: payload,
        favoriteIdsLoaded: true //设置true之后再显示最终的状态, 否则ui在已设置时会闪烁
      };
    case SYNC_ADDRESS_BOOK:
      return {
        ...state,
        addresses: payload
      };
    case SET_DISCOUNT_COPY:
      return {
        ...state,
        discountCopy: payload
      };
    case SYNC_COMMON_BAR_COPY:
      return {
        ...state,
        commonBarCopy: payload
      };
    case SYNC_REWARDS_INFO:
      return {
        ...state,
        rewardsInfo: payload
      };
    case SHOW_FAVORITE_TIP:
      return {
        ...state,
        show_favorite_tip: payload
      };
    case SYNC_USER_PRE_ORDER_LOGIN:
      return {
        ...state,
        userPreOrderLogged: payload
      };
    case SYNC_FAVORITE_CLICK: {
      return {
        ...state,
        favoriteClicked: payload
      };
    }
    case SYNC_USER_BOUGHT_DATA: {
      return {
        ...state,
        userBoughtData: payload
      };
    }
    case SYNC_PDP_SOLDOUT_TIP: {
      return {
        ...state,
        pdpSoldoutTip: payload
      };
    }
    default:
      return state;
  }
}
